// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2eksZ","consentsList":"PatientConsents_consentsList__2FLCZ","consentsListEmpty":"PatientConsents_consentsListEmpty__Q1zjP"};